import { render, staticRenderFns } from "./mix-table-tile.v2.vue?vue&type=template&id=3f83f0c2&scoped=true"
import script from "./mix-table-tile.v2.vue?vue&type=script&setup=true&lang=js"
export * from "./mix-table-tile.v2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mix-table-tile.v2.vue?vue&type=style&index=0&id=3f83f0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83f0c2",
  null
  
)

export default component.exports